module.exports = __webpack_public_path__ + "static/media/de.b55ae913.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/de.svg
// module id = 846
// module chunks = 0